export default "__VITE_ASSET__do$3cM5d__"